import { IconButton } from '@apia/components';
import { getLabel, useImperativeComponentEvents } from '@apia/util';
import { useCallback, useState } from 'react';
import { usePanelActions, usePanelIsLoading } from '../../../actions';

export const RefreshButton = (props: {
  refreshOnStart: boolean;
  refreshOnHome: boolean;
  title: string;
}) => {
  const [isDisabled, setIsDisabled] = useState(false);

  const isLoading = usePanelIsLoading();
  const dispatch = usePanelActions();

  useImperativeComponentEvents({
    disable(newDisabledValue: boolean) {
      setIsDisabled(newDisabledValue);
    },
  });

  return (
    <IconButton
      icon="Refresh"
      variant="buttons.icon-outline"
      className="panel__iconButton"
      size="Md"
      onClick={useCallback(() => {
        void dispatch({ action: 'refresh' });
      }, [dispatch])}
      title={getLabel('lblRefreshPnl', { text: { TOK1: props.title } }).text}
      isLoading={isLoading}
      disabled={isDisabled}
    />
  );
};
